import PrimaryPalette from '../colors';

const theme = {
  colors: {
    primary: PrimaryPalette.mediumEvergreen,
    secondary: PrimaryPalette.lightEvergreen,
    tertiary: PrimaryPalette.darkestGrey,
    link: PrimaryPalette.linkGreen,
    dangerLink: PrimaryPalette.mediumPoppy,
    linkHover: PrimaryPalette.mediumEvergreen,
    dangerLinkHover: PrimaryPalette.darkPoppy,
    formLabel: PrimaryPalette.darkestGrey,
    required: PrimaryPalette.mediumPoppy,
    error: PrimaryPalette.mediumPoppy,
    active: PrimaryPalette.darkGreen,
    helper: PrimaryPalette.lightEvergreen,
    dangerHelper: PrimaryPalette.mediumPoppy,
    dangerChip: PrimaryPalette.darkPoppy,
    listViewHeader: PrimaryPalette.lightEvergreen,
    listViewPrimaryCell: PrimaryPalette.mediumEvergreen,
    listViewSecondaryCell: PrimaryPalette.mediumEvergreen,
    listViewSecondaryInformation: PrimaryPalette.mediumEvergreen,
  },
  fonts: {
    serif: 'Untitled Serif, serif',
    sans: 'Untitled Sans, sans-serif',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    semiBold: 600,
  },
};

export default theme;
